import React from 'react';
import { Grid, TextField } from '@mui/material';
import { SnackContext } from 'src/store/ContextStore';
import { APICONSTANTS } from 'src/components/Constants';
import AnonymousFreeTextBanner from '../pedigree-chart/AnonymousFreeTextBanner';
import axios from 'src/axios';

export default function FamilyNote({
  user,
  onDirtyChange,
  saveRef,
  discardRef
}) {
  const { setSnack } = React.useContext(SnackContext);

  const initialNote = React.useMemo(
    () => user?.familyNote || '',
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const [note, setNote] = React.useState(initialNote);

  const handleChange = (e) => {
    setNote(e.target.value);
    onDirtyChange?.(true);
  };

  const onSave = async () => {
    await axios
      .put(APICONSTANTS.setFamilyNote.replace(':user_id', user._id), {
        familyNote: note
      })
      .then(({ data }) => {
        setNote(data.familyNote);
        onDirtyChange?.(false);
        setSnack({
          status: true,
          msg: 'Family note updated',
          severity: 'success'
        });
      })
      .catch(() => {
        setSnack({
          status: true,
          msg: 'An error occurred',
          severity: 'error'
        });
      });
  };

  const onDiscard = () => {
    setNote(initialNote);
    onDirtyChange?.(false);
  };

  React.useEffect(() => {
    if (saveRef) saveRef.current = onSave;
    if (discardRef) discardRef.current = onDiscard;
  });

  return (
    <>
      <AnonymousFreeTextBanner sx={{ mb: 1.5 }} />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            placeholder="Add a note about this family..."
            value={note}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </>
  );
}
